import CONSTANTS from 'app/constants'
import router from 'app/router'

export default {

    namespaced: true,

    state: {

		wins: {

            band: false,
			threshold: 3

        },

		weight: 'polar',

        player: '',

        period: CONSTANTS.INSIGHTS.PERIOD.ALLTIME,

        players: 0

    },

    getters: {

        active: function(state) {

            return {
				'wins.band': state.wins.band !== false,
				'wins.threshold': state.wins.threshold !== 3,
				'weight': state.weight !== 'polar',
                'period': state.period,
                'players': state.players
            }

        },

        values: function(state) {

            return {
				'wins.band': state.wins.band,
				'wins.threshold': state.wins.threshold,
				'weight': state.weight,
                'period': state.period,
                'players': state.players,
                'player': state.player
            }

        },

		'wins/band': function(state) {

			return state.wins.band

		},

		'wins/threshold': function(state) {

			return state.wins.threshold

		},

		weight: function(state) {

			return state.weight

		},

        period: function(state) {

            return state.period

        },

        players: function(state) {

            return state.players

        }

    },

    mutations: {

        reset: function(state) {

			state.wins.band = false
			state.wins.threshold = 3
			state.weight = 'polar'
            state.period = CONSTANTS.INSIGHTS.PERIOD.ALLTIME
            state.players = 0

        },

		'wins/band': function(state, value) {

			state.wins.band = value

		},

		'wins/threshold': function(state, value) {

			state.wins.threshold = value

		},

		weight: function(state, value) {

			state.weight = value

		},

        period: function(state, value) {

            state.period = value

        },

        players: function(state, value) {

            state.players = value

        }

    },

    actions: {

        analyse: function(context, params) {

            return new Promise(function(resolve) {

                context.commit('reset')

                context.state.player = router.currentRoute.params.player

                if (params !== undefined) {

					if (params['wins.threshold']) context.state.wins.threshold = parseInt(params['wins.threshold'])
					if (params['wins.band']) context.state.wins.band = parseInt(params['wins.band'])
					if (params.weight) context.state.weight = params.weight
                    if (params.period) context.state.period = params.period
                    if (params.players) context.state.players = params.players

                }

                resolve()

            })

        },

        route: function(context) {

            var urlParams = {}
            
			if (context.state.wins.band !== false) urlParams['wins.band'] = context.state.wins.band
			if (context.state.wins.threshold !== 3) urlParams['wins.threshold'] = context.state.wins.threshold
			if (context.state.weight !== 'polar') urlParams.weight = context.state.weight
            if (context.state.period !== 'all') urlParams.period = context.state.period
            if (context.state.players !== 0) urlParams.players = context.state.players

            router.replace({name: 'InsightsPlayer', query: urlParams}).catch(function() {})

        }

    }

}